<template>
    <div class="container">
        <el-page-header @back="$router.go(-1)" style="padding-bottom:10px">
        </el-page-header>
        <div class="search">
            <!-- 筛选 -->
            <my-search :inputArr="inputArr" :searchParams="searchParams" @searchEvent="searchEvent" />
            <el-button size="small" type="primary" class="right" @click="add">添加</el-button>
        </div>
        <!-- 列表 -->
        <my-table isSelection :loading="loading" :tableData="tableData" :tableHeader="tableHeader" :pageParams="pageParams" />

        <!-- 分页组件 -->
        <my-pagination :childMsg="pageParams" @callFather="callFather" />

        <my-dialog :isDialogShow.sync="isDialogShow" :operTitle="operTitle" :operForm="operForm" :operFormArr="operFormArr" :rules="rules" @submitForm="submitForm">
        </my-dialog>
    </div>
</template>

<script>
import {
    delKeywords,
    updateKeywords,
    addKeyword,
    keywordsPageList,
} from "@/network/content/channel.js";
import mixins from "@/mixins/common";
export default {
    name: "keyword",
    mixins: [mixins],
    data() {
        return {
            searchParams: {
                keywordsName: "",
            },
            inputArr: [
                {
                    name: "keywordsName",
                    defaultText: "请输入关键字名称",
                },
            ],
            tableHeader: Object.freeze([
                {
                    name: "关键字",
                    prop: "keywordsName",
                },
                // {
                //     name: "状态",
                //     prop: "status",
                // },
                // {
                //     name: "type",
                //     prop: "type",
                // },
                {
                    name: "创建时间",
                    prop: "createTime",
                },
                {
                    name: "操作",
                    prop: "operation",
                    width: "300",
                    operation: [
                        {
                            name: "编辑",
                            clickFun: this.edit,
                        },
                        {
                            name: "删除",
                            clickFun: this.deleteItem,
                        },
                    ],
                },
            ]),
            //参数
            operForm: {
                keywordsName: "", //关键字名称
                type: "", //关键字类型
            },
            operFormArr: [
                {
                    name: "keywordsName",
                    label: "关键字名称",
                    defaultText: "请输入关键字名称",
                },
                // {
                //     name: "type",
                //     label: "关键字类型",
                //     defaultText: "请输入关键字类型",
                // },
            ],
            // 弹出框的表单验证
            rules: {
                keywordsName: [
                    {
                        required: true,
                        message: "请输入关键字名称",
                        trigger: "blur",
                    },
                ],
                // type: [
                //     {
                //         required: true,
                //         message: "请输入关键字类型",
                //         trigger: "blur",
                //     },
                // ],
            },
        };
    },
    computed: {},
    methods: {
        getInitData(isSearch) {
            let { keywordsName } = this.searchParams;
            let params = {
                data: {
                    keywordsName,
                },
                current: isSearch ? 1 : this.pageParams.currentPage,
                size: this.pageParams.pageSize,
            };
            keywordsPageList(params).then((e) => {
                this.loading = false;
                let { code, data, msg } = e.data;
                if (code == 200) {
                    this.tableData = data.records;
                    this.pageParams.total = data.total;
                }
            });
        },
        //搜索
        searchEvent() {
            this.getInitData(true);
        },
        add() {
            // 清空
            this.operForm = {};
            this.operTitle = true;
            this.isDialogShow = true;
        },
        edit(row) {
            this.operForm = { ...row };
            this.isDialogShow = true;
            this.operTitle = false;
        },
        //提交表单
        async submitForm({ valid, operTitle }) {
            // operTitle ture添加  否则是编辑
            if (valid) {
                let api = operTitle ? addKeyword : updateKeywords;
                let { data } = await api(this.operForm);
                if (data.code == 200) {
                    this.isDialogShow = false;
                    this.$message.success("操作成功");
                    this.getInitData();
                }
            }
        },
        deleteItem(row) {
            this.$confirm("删除该条数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    let { data } = await delKeywords({ id: row.id });
                    if (data.code == 200) {
                        this.$message.success("删除成功");
                        this.getInitData();
                    }
                })
                .catch(() => { });
        },
    },
};
</script>

<style lang="scss" scoped>
.search {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
</style>
